var cov_2e09cnoaeq = function () {
  var path = "/Users/spana/SHEIN/shineout/src/CardGroup/styles/index.ts",
      hash = "346badae2e05b8e4bf6c2326c5008543f4a590f4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/CardGroup/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 30
        },
        end: {
          line: 5,
          column: 69
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var cardGroupLess = {};
import genaration from '../../utils/classname';
export var cardGroupClass = (cov_2e09cnoaeq.s[0]++, genaration(cardGroupLess, 'card-group'));